module.exports = __webpack_public_path__ + "static/media/Campaign Analytics.665bf77b.jpg";